import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { BrowserModule } from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';

const routes: Routes = [{
  path: 'about', component: AboutComponent
}];

@NgModule({
  declarations: [
    AboutComponent
  ],
  imports: [
    RouterModule.forChild(routes), 
    BrowserModule,
    MatCardModule,
    MatGridListModule
  ],
  exports: [RouterModule] 
})
export class AboutModule {

  constructor(

  ) {

  }

}
